Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Country", {
    enumerable: true,
    get: function() {
        return Country;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Country {
    findCurrencyByCode(code) {
        return this.currencyLookups.get(code.toLowerCase());
    }
    resolveCurrencyByCode(code) {
        return this.findCurrencyByCode(code) ?? this.defaultCurrency;
    }
    constructor(countryDef, allCurrencies){
        _define_property(this, "uid", void 0);
        _define_property(this, "code", void 0);
        _define_property(this, "name", void 0);
        _define_property(this, "defaultLang", void 0);
        _define_property(this, "currencies", void 0);
        _define_property(this, "defaultCurrency", void 0);
        _define_property(this, "currencyLookups", void 0);
        this.uid = countryDef.uid;
        this.code = countryDef.code;
        this.defaultLang = countryDef.defaultLang;
        this.name = countryDef.name;
        this.currencies = countryDef.currencyUids.map((currencyUid)=>allCurrencies.find((currency)=>currency.uid === currencyUid));
        this.defaultCurrency = this.currencies.find((currency)=>currency.uid === countryDef.defaultCurrencyUid);
        this.currencyLookups = new Map();
        this.currencies.forEach((currency)=>{
            this.currencyLookups.set(currency.code.toLowerCase(), currency);
        });
    }
}
